export const muiClasses = {
  Tab: {
    root: 'fs-3 px-2 text-transform-none w-auto',
    wrapper: 'flex-row',
  },
}
